import React from "react";
import classNames from "classnames/bind";
import styles from "./QuantityControl.module.scss";
import useTranslations from "../../hooks/useTranslations";

const cx = classNames.bind(styles);

const QuantityControl = ({ quantity, onIncrease, onDecrease, className }) => {
  const currentTranslations = useTranslations();

  return (
    <div className={cx("quantity-control", className)}>
      <span className={cx("quantity-label")}>
        {currentTranslations?.Cart?.quantity}:
      </span>
      <button className={cx("quantity-btn")} onClick={onDecrease}>
        -
      </button>
      <span className={cx("quantity-value")}>{quantity}</span>
      <button className={cx("quantity-btn")} onClick={onIncrease}>
        +
      </button>
    </div>
  );
};

export default QuantityControl;
